import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Box, Button, Stack, Tab, Tabs, useMediaQuery } from '@mui/material';
import { useFormik } from 'formik';
import _ from 'lodash';
import React from 'react';
import { useMutation } from 'react-fetching-library';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useManager } from '../../../../pages/Manager';
import { updateEmployeeApplication } from '../../../../services/request';
import defaultImage from './default.png';
import EmployeeData from './tabs/EmployeeData';
import SunActivePoints from './tabs/SunActivePoints';
import Reviews from './tabs/Reviews';
import { Comment, Star } from '@mui/icons-material';

const validationSchema = Yup.object({
  name: Yup.string().required('To pole nie może być puste'),
  surname: Yup.string().required('To pole nie może być puste'),
  correspondence_email: Yup.string().email('Proszę podać poprawny adres e-mail')
});

export default function ManagerEmployeeApplicationForm({ data }) {
  const { managerEmployee: rowData, setManagerEmployee: setRowData } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { seasonIdentifier } = useSelector(state => state.app);
  const { loading, mutate } = useMutation(updateEmployeeApplication);
  const [currentTab, setCurrentTab] = React.useState(0);
  const ref = React.useRef(null);
  const [preview, setPreview] = React.useState(
    _.isNil(rowData.photo) ? defaultImage : rowData.photo
  );
  const [isDefaultPhoto, setisDefaultPhoto] = React.useState(
    rowData.is_default_photo
  );
  console.log('rd', rowData);
  const formik = useFormik({
    initialValues: {
      id: rowData.id,
      employee_type: !_.isNil(rowData.employee_type) ? rowData.employee_type : null,
      name: !_.isNil(rowData.name) ? rowData.name : '',
      surname: !_.isNil(rowData.surname) ? rowData.surname : '',
      birth_date: !_.isNil(rowData.birth_date) ? rowData.birth_date : null,
      correspondence_email: !_.isNil(rowData.correspondence_email) ? rowData.correspondence_email : '',
      phone: !_.isNil(rowData.phone) ? rowData.phone : '',
      function_type: !_.isNil(rowData.function_type) ? rowData.function_type : '',
      experience: !_.isNil(rowData.experience) ? rowData.experience : '',
      company_clothing_size: !_.isNil(rowData.company_clothing_size) ? rowData.company_clothing_size : '',
      additional_comments: !_.isNil(rowData.additional_comments) ? rowData.additional_comments : '',
      about_me: !_.isNil(rowData.about_me) ? rowData.about_me : '',
      other_pedagogical_qualifications: !_.isNil(rowData.other_pedagogical_qualifications) ? rowData.other_pedagogical_qualifications : '',
      other_additional_qualifications: !_.isNil(rowData.other_additional_qualifications) ? rowData.other_additional_qualifications : '',
      other_skills: !_.isNil(rowData.other_skills) ? rowData.other_skills : '',
      what_experience: !_.isNil(rowData.what_experience) ? rowData.what_experience : '',
      where_experience: !_.isNil(rowData.where_experience) ? rowData.where_experience : '',
      role_experience: !_.isNil(rowData.role_experience) ? rowData.role_experience : '',
      pedagogical_qualifications: !_.isNil(rowData.pedagogical_qualifications) ? rowData.pedagogical_qualifications : [],
      additional_qualifications: !_.isNil(rowData.additional_qualifications) ? rowData.additional_qualifications : [],
      range_of_skills: !_.isNil(rowData.range_of_skills) ? rowData.range_of_skills : [],
      is_photo_deleted: false,
      is_photo_changed: false,
      instructor_sport_type: !_.isNil(rowData.instructor_sport_type) ? rowData.instructor_sport_type : null,
      instructor_specialization: !_.isNil(rowData.instructor_specialization) ? rowData.instructor_specialization : null
    },
    validationSchema,
    enableReinitialize: true, // Allows form values to reset when rowData changes
    onSubmit: async values => {
      try {
        await mutate(rowData.id, values);
        toast.success('Zaktualizowano dane');
      } catch (err) {
        toast.error('Błąd zapisu');
      }
    }
  });

  const handleSubmit = async (applicationId, values) => {
    const { error, payload } = await mutate(applicationId, values);
    if (!error) {
      formik.resetForm({
        values: { ...payload, is_photo_deleted: false, is_photo_changed: false }
      });
      setRowData(payload);
      setisDefaultPhoto(payload.is_default_photo);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (_.isArray(payload)) {
        toast.error(payload[0]);
      } else {
        toast.error('Nie udało się zapisać zmian');
      }
    }
  };


  return (
    <form onSubmit={formik.handleSubmit} style={{ maxWidth: '100%', width: '100%' }}>
      <Tabs
        sx={{ mb: 2 }}
        value={currentTab}
        onChange={(e, value) => setCurrentTab(value)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        <Tab icon={<AssignmentIndIcon />} label="Dane pracownika" />
        <Tab icon={<Comment />} label="Opinie" />
        {rowData?.periods_type === 'obozy' ? <Tab icon={<Star />} label="Punkty" /> : null}
      </Tabs>
      <Box style={{ textAlign: 'center' }}>
        <Button
          variant="contained"
          disabled={!formik.dirty || loading}
          fullWidth
          type="submit"
        >
          {loading ? 'Zapisywanie...' : 'Zapisz zmiany'}
        </Button>
      </Box>
      <Stack p={1} mt={2} height={isMobile ? undefined : '65vh'} overflow="auto" width={isMobile ? '40vh' : '100%'}>
        {currentTab === 0 ? (
          <EmployeeData
            formik={formik}
            fileInputRef={ref}
            loading={loading}
            preview={preview}
            isDefaultPhoto={isDefaultPhoto}
          />
        ) : currentTab === 1
          ? <Reviews />
          : currentTab === 2
            ? <SunActivePoints />
            : null}
      </Stack>
    </form>
  );
}
